import { Autocomplete, Card, CardContent, Chip, CircularProgress, IconButton, TextField, Tooltip } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import TabelPerencanaan from 'examples/Tables/TabelPerencanaan'
import { CustomDescrypt } from 'global/func'
import { getDataWithResponse } from 'global/getFunc'
import { postDataWithResponse } from 'global/postFunc'
import React, { useEffect, useState } from 'react'
import { decodeToken } from 'react-jwt'
import { Link, Route, Routes } from 'react-router-dom'
import userStore from 'store/userStore'
import RincianBelanja from './RincianBelanja'
import { MaterialReactTable } from 'material-react-table'
import { ArrowCircleRight } from '@mui/icons-material'
import Detail from './Detail'

const Perencanaan = () => {
    return (
        <Routes>
            <Route path="" element={<Data />} />
            <Route path="detail" element={<Detail />} />
            <Route path="rincian-belanja" element={<RincianBelanja />} />
        </Routes>
    )
}

const Data = () => {
    const { user, tahunAnggaran, addReq } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const [loading, setLoading] = useState(false)

    const [listOpd, setListOpd] = useState([])

    const reqOpd = () => {
        setLoading(true)
        addReq()
        postDataWithResponse(
            '/sa/check-perencanaan-opd',
            {
                ta: tahunAnggaran.ta,
            },
            decryptedUser,
            (res) => {
                console.log(res);
                setListOpd(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqOpd()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const columns = [
        {
            accessorKey: 'nama_pd',
            header: 'OPD',
            Cell: ({ cell }) => (
                <>
                    <ArgonTypography
                        fontWeight='bold'
                        fontSize='small'
                        variant="inherit"
                    >
                        {cell.row.original.kd_pd} {cell.getValue()}
                    </ArgonTypography>
                    {
                        cell.row.original.anggaran_terinput === 0 ?
                            <Chip size='small' label='Belum Menginput Perencanaan' color='error' variant="outlined" />
                            :
                            cell.row.original.anggaran_terinput === cell.row.original.anggaran_opd ?
                                <Chip size='small' label='Input Perencanaan Selesai' color='success' variant="outlined" />
                                :
                                <Chip size='small' label='Input Perencanaan belum Selesai' color='warning' variant="outlined" />
                    }
                </>
            )
        },
        {
            accessorKey: 'anggaran_opd',
            header: 'Anggaran',
            Cell: ({ cell }) => (
                <ArgonTypography
                    // fontWeight={(cell.row.original.status === 'Program' || cell.row.original.status === 'Kegiatan') === 'Program' && 'bold'}
                    variant="inherit"
                    fontSize="small"
                >
                    {
                        parseInt(cell.getValue())?.toLocaleString?.('id-ID', {
                            style: 'currency',
                            currency: 'IDR',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })
                    }
                </ArgonTypography>
            )
        },
        {
            accessorKey: 'anggaran_terinput',
            header: 'Anggaran Terinput',
            Cell: ({ cell }) => (
                <ArgonTypography
                    // fontWeight={(cell.row.original.status === 'Program' || cell.row.original.status === 'Kegiatan') === 'Program' && 'bold'}
                    variant="inherit"
                    fontSize="small"
                >
                    {
                        parseInt(cell.getValue())?.toLocaleString?.('id-ID', {
                            style: 'currency',
                            currency: 'IDR',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })
                    }
                </ArgonTypography>
            )
        },
        {
            accessorKey: 'komponen_terinput',
            header: 'Komponen Belanja',
            Cell: ({ cell }) => (
                <ArgonTypography
                    // fontWeight={(cell.row.original.status === 'Program' || cell.row.original.status === 'Kegiatan') === 'Program' && 'bold'}
                    variant="inherit"
                    fontSize="small"
                >
                    {cell.getValue()}
                </ArgonTypography>
            )
        },
    ];

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={1}>
                <Card>
                    <CardContent>
                        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" py={2}>
                            <ArgonTypography variant="h6">Tabel Perencanaan OPD</ArgonTypography>
                        </ArgonBox>
                        <ArgonBox
                            sx={{
                                "& .MuiTableRow-root:not(:last-child)": {
                                    "& td": {
                                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                            `${borderWidth[1]} solid ${borderColor}`,
                                    },
                                },
                            }}
                            spacing={2}
                        >

                            <MaterialReactTable
                                columns={columns}
                                data={listOpd}
                                // enableExpanding
                                // enableExpandAll
                                muiTableHeadCellProps={{
                                    sx: {
                                        fontSize: '0.875rem !important',
                                        color: 'text.main !important'
                                    }
                                }}
                                muiTableFooterCellProps={{
                                    sx: {
                                        fontSize: '0.875rem !important',
                                        color: 'text.main !important'
                                    }
                                }}
                                muiTopToolbarProps={{
                                    sx: { fontSize: '0.875rem' }
                                }}
                                initialState={{
                                    expanded: true
                                }}
                                enablePagination={false}
                                enableColumnFilters={false}
                                enableSorting={true}
                                state={{ isLoading: loading }}
                                enableRowActions={true}
                                positionActionsColumn='first'
                                displayColumnDefOptions={{
                                    'mrt-row-actions': {
                                        header: 'Action', //change header text
                                        size: 5, //make actions column wider
                                        alignment: 'left',
                                    }
                                }}
                                renderRowActions={({ row }) => [
                                    <Tooltip title="Detail Perencanaan" key={0}>
                                        <IconButton
                                            id="basic-button"
                                            color='primary'
                                            component={Link}
                                            to='/admin/perencanaan/detail'
                                            state={row.original}
                                        >
                                            <ArrowCircleRight fontSize='small' />
                                        </IconButton>
                                    </Tooltip>,
                                ]}
                            />
                        </ArgonBox>
                    </CardContent>
                </Card>
            </ArgonBox>
        </ArgonBox>
    )
}

const Data2 = () => {
    const { user, tahunAnggaran, addReq } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const decodedUser = decodeToken(decryptedUser)

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const [listOpd, setListOpd] = useState([])
    const [opd, setOpd] = useState({})

    const reqOpd = () => {
        setLoading(true)
        addReq()
        postDataWithResponse(
            '/opd/filter',
            {
                jenis: '',
                nama: '',
            },
            null,
            (res) => {
                console.log(res);
                setListOpd(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqOpd()
        console.log(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const reqPerencanaan = (params) => {
        if (params) {
            setLoading(true)
            addReq()
            getDataWithResponse(
                // `/admin-opd/get-tr-perencanaan-opd/${tahunAnggaran.ta}/${params}`,
                `/admin-opd/get-tr-perencanaan-opd/${tahunAnggaran.ta}/${params}`,
                decryptedUser,
                (res) => {
                    setData(res)
                    setLoading(false)
                },
                (res) => {
                    console.log(res)
                    setLoading(false)
                }
            );
        }
    }

    useEffect(() => {
        console.log(decodedUser);
        setOpd({
            kd_pd: decodedUser.kd_pd,
            nm_pd: decodedUser.nm_pd
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        console.log(opd);
        reqPerencanaan(opd.kd_pd)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [opd])

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={1}>
                <Card>
                    <CardContent>
                        <ArgonBox mb={1}>
                            <ArgonBox mb={1} ml={0.5}>
                                <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                    Daftar OPD
                                </ArgonTypography>
                            </ArgonBox>
                            <ArgonBox mb={1}>
                                <Autocomplete
                                    id="combo-box-demo"
                                    options={listOpd}
                                    fullWidth
                                    required
                                    getOptionLabel={(option) => option.kd_pd + ' ' + option.nama_pd}
                                    onChange={(event, newValue) => {
                                        newValue !== null && setOpd(newValue)
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                        newInputValue === "" && setOpd({})
                                        // newInputValue.length > 7 && reqDpt()
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            InputProps={{
                                                ...params.InputProps,
                                                required: true,
                                                endAdornment: (
                                                    <>
                                                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </ArgonBox>
                        </ArgonBox>
                        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" py={2}>
                            <ArgonTypography variant="h6">Tabel Perencanaan OPD</ArgonTypography>
                        </ArgonBox>
                        <ArgonBox
                            sx={{
                                "& .MuiTableRow-root:not(:last-child)": {
                                    "& td": {
                                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                            `${borderWidth[1]} solid ${borderColor}`,
                                    },
                                },
                            }}
                            spacing={2}
                        >

                            <TabelPerencanaan
                                data={data}
                                loading={loading}
                                opd={opd}
                                baseUrl="/admin/perencanaan"
                                allowEdit={false}
                            />
                        </ArgonBox>
                    </CardContent>
                </Card>
            </ArgonBox>
        </ArgonBox>
    )
}

export default Perencanaan